export enum CommonStatId {
  SkinPattern = 718,
}
